

















import Vue from 'vue';
import store from '@/store';
import { GroupBuilderKind } from '@/store/getStarted';

import { GoogleClassroomCourse } from '@/api/auth/google';

import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';
import GoogleClassroomCoursePicker from '@/components/GoogleClassroomCoursePicker.vue';
import { GettingStartedPeerGroup } from '@/models';

export default Vue.extend({
  components: {
    GetStartedNav,
    GoogleClassroomCoursePicker
  },

  computed: {
    courses(): GoogleClassroomCourse[] {
      const groupBuilder = store.state.getStarted.groupBuilder;

      if (groupBuilder.kind === GroupBuilderKind.GOOGLE_CLASSROOM) {
        return groupBuilder.courses;
      } else {
        console.error(
          'On Google Classroom picker page, but not in Google Classroom workflow'
        );

        return [];
      }
    },

    peerGroups(): GettingStartedPeerGroup[] {
      return store.state.getStarted.existingPeerGroups;
    },

    activeAliases(): string[] {
      return this.peerGroups.flatMap(pg => (pg.alias ? [pg.alias] : []));
    }
  },

  methods: {
    select(course: GoogleClassroomCourse) {
      store.dispatch.getStarted.selectGoogleClassroomCourse(course);
    }
  }
});
